module.exports = __webpack_public_path__ + "img/foggy.ae1e2b75.png";